<template lang='pug'>
  base-card.cards.service.component.actionable.container
    img( v-if='item.image' :src='item.image.src' )
    img( v-else='item.image' src='/no-image.png' )
    bf-flex.column.overlay
      h6.title {{ item.title }}
      bf-flex
        //- span.duration {{ item.duration }} mins
        //- span.price ${{ item.price }}
</template>

<script>
  import { db } from '@/main'
  import BaseCard from '@/components/base-card'

  export default {
    name: 'rsv-card.component',

    props: {
      item: Object,
    },

    components: {
      BaseCard
    },

    // data() {
    //   return {
    //     images: [],
    //   }
    // },

    // firestore() {
    //   return {
    //     images: db.collection( 'services' ).doc( this.srv.id ).collection( 'images' ).orderBy( 'index' )
    //   }
    // },

    // computed: {
    //   image() {
    //     return this.images.length ? this.images[0].src : ''
    //   }
    // }

    // computed: {
    //   rsvs() {
    //     return this.reservations.filter( r =>
    //       r.datetime.start.toDate().getDate() == this.rsv.datetime.start.toDate().getDate()
    //     )
    //   },

    //   count() {
    //     return this.rsvs.indexOf( this.rsv )
    //   },

    //   total() {
    //     return this.rsvs.length
    //   },

    //   inactive() {
    //     return this.rsv.datetime.end.toDate() < new Date()
    //   }
    // },

    // methods: {
    //   pending(r) {
    //     return r.status == 'Pending Cancellation'
    //   },

    //   canceled(r) {
    //     return r.status == 'Canceled'
    //   }
    // }
  }
</script>

<style scoped lang='stylus'>
  .cards.service
    height 160px
    box-shadow 0 1px 2px #8d949e
    img
      height 100%
      width 100%
      object-fit cover

    .overlay
      position absolute
      height 100%
      width 100%
      top 0
      left 0
      padding 16px
      box-sizing border-box
      background linear-gradient(
        180deg,
        rgba( 0 0 0 0 ),
        rgba( 0 0 0 .25 ),
        rgba( 0 0 0 .75 )
      )
      color white
      z-index 1
    .title
      margin-top auto
      margin-bottom 8px
    
    span.price
      margin-left auto
</style>
